import { useState } from "react";

import { useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import ListItem from "@mui/material/ListItem";

import constants from "../../assets/constants";
import { deepCopyObject, helperGetIsoDate } from "../../utils/helpers";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogMessage from "../ui/omniDialogMessage";
import DialogTitle from "../ui/omniDialogTitle";
import SymptomScale from "../ui/symptomScale";
import WidgetList from "../ui/widgetList";

const PatientSymptomsDialog = props => {
  const {
    open,
    dialogTitle = "Symptom Tracking",
    okMessage = "Ok",
    cancelMessage = "Cancel",
    maxWidth = "sm",
    fullWidth = true,
    symptomODMs = [],
    daysInThePast = 0,
  } = props;

  const getMessage = inthePast => {
    let newData = "How much did these symptoms affect you ";
    if (inthePast === 0) {
      newData += "today?";
    } else if (inthePast === 1) {
      newData += "yesterday?";
    } else {
      let aDay = helperGetIsoDate(inthePast);
      let date = new Date(aDay);
      newData += `last ${constants.weekDayNamesLong[date.getDay()]}?`;
    }
    return newData;
  };

  const initializeData = (theData, daysInThePast) => {
    let newData = [];
    let targetDateString = helperGetIsoDate(daysInThePast).substring(0, 10);

    for (let i = 0; i < theData.length; ++i) {
      let found = theData[i].timeSeries.find(obj => obj.date === targetDateString);
      if (found != null) {
        newData.push(found.value);
      } else if (theData[i].timeSeries.length > 0) {
        let theValue = theData[i].timeSeries[theData[i].timeSeries.length - 1].value;
        newData.push(theValue);
      } else {
        newData.push(5);
      }
    }
    return newData;
  };

  const [newSymptomData, setNewSymptomData] = useState(initializeData(symptomODMs, daysInThePast));

  const handleChange = (newValue, valueIndex) => {
    newSymptomData[valueIndex] = newValue;
    setNewSymptomData(newSymptomData);
  };

  const onAcceptHandler = () => {
    let targetDateString = helperGetIsoDate(daysInThePast).substring(0, 10);
    let returnSymptoms = deepCopyObject(symptomODMs);

    for (let i = 0; i < returnSymptoms.length; ++i) {
      let foundIndex = returnSymptoms[i].timeSeries.findIndex(obj => obj.date === targetDateString);
      if (foundIndex < 0) {
        //its the add case
        let theNewEntry = {
          date: targetDateString,
          value: newSymptomData[i],
          note: "",
        };
        returnSymptoms[i].timeSeries.push(theNewEntry);
        returnSymptoms[i].timeSeries.sort();
      } else {
        returnSymptoms[i].timeSeries[foundIndex].value = newSymptomData[i];
      }
    }

    props.onAccept(returnSymptoms);
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onCloseHandler}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogMessage sx={{ marginBottom: theme.spacing(1), marginLeft: theme.spacing(2) }}>
          {getMessage(daysInThePast)}
        </DialogMessage>

        <WidgetList>
          {symptomODMs.map((symptom, index) => {
            return (
              <ListItem
                key={`symptom${index}`}
                disableGutters={true}
                sx={{
                  padding: 0,
                  margin: 0,
                  marginBottom: theme.spacing(1),
                  backgroundColor: theme.palette.commonground.main,
                  color: theme.palette.commonground.contrastText,
                }}
              >
                <SymptomScale
                  defaultValue={newSymptomData[index]}
                  // defaultValue={symptom.newReportedValue}
                  defaultLabel={symptom.name}
                  valueEditedHandler={handleChange}
                  valueIndex={index}
                />
              </ListItem>
            );
          })}
        </WidgetList>
      </DialogContent>
      <DialogActions>
        {cancelMessage && (
          <Button onClick={onCloseHandler} color="secondary" variant="contained">
            {cancelMessage}
          </Button>
        )}
        <Button onClick={onAcceptHandler} color="secondary" variant="contained">
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PatientSymptomsDialog;
